import React from "react";
import { useEffect, useState } from "react";
import ArrayFieldSection from "./ArrayFieldSection";

const formatDate = (dateStr) => {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return "";
  const offset = date.getTimezoneOffset();
  const localDate = new Date(date.getTime() - offset * 60 * 1000);
  return localDate.toISOString().split("T")[0];
};

const EditFieldRenderer = ({
  field,
  formData,
  handleInputChange,
  handleDropdownChange,
  handleArrayChange,
  handleAddItem,
  handleRemoveItem,
  dropdownData,
  apiUrl
}) => {

  const [decryptedPassword, setDecryptedPassword] = useState("");

useEffect(() => {
  const fetchPlainPassword = async () => {
    if (field.type === "plainpassword" && formData._id) {
      try {
        const res = await fetch(
          `${apiUrl || ""}/plaintext-passwords/${formData._id}`
        );
        const data = await res.json();
        if (data.plainPassword) {
          setDecryptedPassword(data.plainPassword);
        }
      } catch (error) {
        console.error("Failed to fetch plain password:", error);
        setDecryptedPassword("Error fetching");
      }
    }
  };

  fetchPlainPassword();
}, [field, formData._id]);

console.log(decryptedPassword);

  const rawValue = formData[field.fields] || "";
  const value =
    field.type === "date" && rawValue ? formatDate(rawValue) : rawValue;

  if (field.checkBox || field.subfields) {
    return (
      <ArrayFieldSection
        field={field}
        formData={formData}
        handleArrayChange={handleArrayChange}
        handleAddItem={handleAddItem}
        handleRemoveItem={handleRemoveItem}
        dropdownData={dropdownData}
      />
    );
  }

  const values = Array.isArray(formData[field.fields])
    ? formData[field.fields].map((v) => (typeof v === "object" ? v._id : v))
    : [];

  const isReadOnly = field.edit === "false";



  return (
    <div className="form-group">
      <label className="form-label">{field.fields}</label>

      {field.api && field.type === "ObjectId" ? (
        field.multiple === "true" ? (
          <>
            <select
              className="form-select"
              value=""
              onChange={(e) => {
                const selectedValue = e.target.value;
                if (!selectedValue) return;
                const updated = [...values, selectedValue].filter(
                  (v, i, self) => self.indexOf(v) === i
                );
                handleInputChange({
                  target: { name: field.fields, value: updated },
                });
              }}
              disabled={isReadOnly}
            >
              <option value="">Select {field.fields}</option>
              {dropdownData[field.fields]
                ?.filter((item) => !values.includes(item.id))
                .map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.label}
                  </option>
                ))}
            </select>

            {/* Bubbles */}
            <div className="selected-bubbles">
              {values.map((val) => {
                const label =
                  dropdownData[field.fields]?.find((i) => i.id === val)
                    ?.label || val;
                return (
                  <span key={val} className="bubble">
                    {label}
                    {!isReadOnly && (
                      <span
                        className="bubble-remove"
                        onClick={() => {
                          const updated = values.filter((v) => v !== val);
                          handleInputChange({
                            target: {
                              name: field.fields,
                              value: updated,
                            },
                          });
                        }}
                      >
                        &nbsp;×
                      </span>
                    )}
                  </span>
                );
              })}
            </div>
          </>
        ) : (
          <select
            className="form-select"
            name={field.fields}
            value={
              typeof formData[field.fields] === "object"
                ? formData[field.fields]._id
                : formData[field.fields]
            }
            onChange={handleDropdownChange}
            disabled={isReadOnly}
          >
            <option value="">Select {field.fields}</option>
            {dropdownData[field.fields]?.map((item) => (
              <option key={item.id} value={item.id}>
                {item.label}
              </option>
            ))}
          </select>
        )
      ) : field.options ? (
        <select
          className="form-select"
          name={field.fields}
          value={value}
          onChange={handleInputChange}
          disabled={isReadOnly}
        >
          <option value="">Select {field.fields}</option>
          {field.options.map((opt, idx) => (
            <option key={idx} value={opt}>
              {opt}
            </option>
          ))}
        </select>
      ) : field.type === "plainpassword" ? (
        <input
          className="form-input"
          type="text"
          name={field.fields}
          value={decryptedPassword}
          readOnly
        />
      ) : (
        <input
          className="form-input"
          type={
            field.type === "date"
              ? "date"
              : field.type === "number"
              ? "number"
              : "text"
          }
          name={field.fields}
          value={value}
          onChange={(e) => {
            if (field.type === "number") {
              const newValue = e.target.value;
              if (/^\d*$/.test(newValue)) {
                handleInputChange(e);
              }
            } else {
              handleInputChange(e);
            }
          }}
          disabled={isReadOnly}
        />
      )}
    </div>
  );
};

export default EditFieldRenderer;
